import * as React from 'react';
import ApiClient from 'src/services/api-client/ApiClient';
import JuridicalPersonData from 'src/value-objects/JuridicalPersonData';
import
  JuridicalAdditionalDataFormComponent, { JuridicalAdditionalComponentProps }
  from 'src/modules/my-account/juridical-profile-update/forms/JuridicalAdditionalDataForm.component';
import EnumTypes from 'src/services/EnumStates/EnumTypes';

export interface JuridicalAdditionalContainerProps {
  formData: JuridicalPersonData;
  handleChange: (key: string) => (value: string | File | boolean) => void;
}

class JuridicalAdditionalDataFormContainer extends React.Component<JuridicalAdditionalContainerProps> {

  public state = {
    maritalStatusOptions: [],
    maritalTypeOptions: [],
    maritalEconomicStatus: [],
    maritalProfession: [],
  };

  public componentWillMount(): void {
    ApiClient.constants.indexMaritalStatuses()
      .then(
        (response) => {
          const states = [];
          for (let key of Object.keys(response.data.data)) {
            states.push({
              name: EnumTypes.getMaritalStatusName(response.data.data[key]),
              value: key.toString()
            });
          }
          this.setState({
            maritalStatusOptions: states,
          });
        }
      );

    ApiClient.constants.indexTypeStatuses()
      .then(
        (response) => {
          const states = [];
          for (let key of Object.keys(response.data.data)) {
            states.push({
              name: EnumTypes.getMaritalPropertyRegimeName(response.data.data[key]),
              value: key.toString()
            });
          }
          this.setState({
            maritalTypeOptions: states,
          });
        }
      );

    ApiClient.constants.indexEconomicStatuses()
      .then(
        (response) => {
          const states = [];
          for (let key of Object.keys(response.data.data)) {
            states.push({
              name: EnumTypes.getMaritalEconomicStatusName(response.data.data[key]),
              value: key.toString()
            });
          }
          this.setState({
            maritalEconomicStatus: states,
          });
        }
      );

    ApiClient.constants.indexProfessions()
      .then(
        (response) => {
          const states = [];
          for (let key of Object.keys(response.data.data)) {
            states.push({
              name: EnumTypes.getOccupationTypesName(response.data.data[key]),
              value: key.toString()
            });
          }
          this.setState({
            maritalProfession: states,
          });
        }
      );
  }

  public render(): React.ReactNode {
    return (
      <JuridicalAdditionalDataFormComponent {...this.getComponentProps()} />
    );
  }

  private getComponentProps(): JuridicalAdditionalComponentProps {
    return {
      handleChange: (key: string) => this.props.handleChange(key),
      formData: this.props.formData!,
      maritalStatusOptions: this.state.maritalStatusOptions,
      maritalTypeOptions: this.state.maritalTypeOptions,
      maritalEconomicStatus: this.state.maritalEconomicStatus,
      maritalProfession: this.state.maritalProfession,
    };
  }
}

export default JuridicalAdditionalDataFormContainer;


// WEBPACK FOOTER //
// ./src/modules/my-account/juridical-profile-update/forms/JuridicalAdditionalDataForm.container.tsx